import {
  all, put, select, take,
} from 'redux-saga/effects';
import { mapComponentLastBoundsChanged } from './mapComponent.actionCreators';
import { MAP_COMPONENT_SET_LAST_BOUNDS } from './mapComponent.actionTypes';
import { areLastBoundsEqual } from './mapComponent.helpers';
import { mapComponentLastBoundsSelector } from './mapComponent.selectors';
import { type LastBounds } from './mapComponent.state';

export function* mapComponentSagas() {
  yield all([
    watchLastBoundsChanges(),
  ]);
}

function* watchLastBoundsChanges() {
  let previous: LastBounds | null = yield select(mapComponentLastBoundsSelector);
  while (true) {
    yield take(MAP_COMPONENT_SET_LAST_BOUNDS);
    const current: LastBounds | null = yield select(mapComponentLastBoundsSelector);
    if (!areLastBoundsEqual(previous, current)) {
      yield put(mapComponentLastBoundsChanged({ previousBounds: previous, newBounds: current }));
    }
    previous = current;
  }
}
